export default __webpack_public_path__ + "static/apple-icon-120x120-23344cbbeda9a0c4a9f50f5a8b722e99.png";